import { render, staticRenderFns } from "./create-warehouse.vue?vue&type=template&id=6f1fd529&"
import script from "./create-warehouse.vue?vue&type=script&lang=ts&"
export * from "./create-warehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports